import { render, staticRenderFns } from "./danhSachTraiCay.vue?vue&type=template&id=dcaa6b14&scoped=true&"
import script from "./danhSachTraiCay.vue?vue&type=script&lang=js&"
export * from "./danhSachTraiCay.vue?vue&type=script&lang=js&"
import style0 from "./danhSachTraiCay.vue?vue&type=style&index=0&id=dcaa6b14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcaa6b14",
  null
  
)

export default component.exports